export const hasNestedObjects = (obj: any): boolean => {
	return (
		obj &&
		typeof obj === 'object' &&
		!Array.isArray(obj) &&
		Object.keys(obj).some((key) => typeof obj[key] === 'object')
	);
};
